<template>
  <main class="md:px-44 px-7">
    <section class="grid pt-9 pb-4 gap-16 content-start items-start w-full">
      <article class="grid gap-4 md:w-80 md:mx-auto justify-center">
        <div class="h-64 w-44 justify-self-center">
          <Vue3Lottie ref="lottie" :animationData="AutoCrossAnimation" :speed="1" :loop="true" />
        </div>
        <div class="grid gap-5 text-center">
          <p class="text-3xl font-blogger font-bold text-headingColor width17rem">Oops!</p>
          <p class="text-center text-headingColor font-myriad text-base width17rem">{{ message }}</p>
        </div>
      </article>
    </section>
    <!-- overLayGoBack -->
    <over-lay-go-back :starterOverLay="isOverLay" @on-click-back-prev="handleBackToPrev"/>
  </main>
</template>
<script>
import { mapGetters } from 'vuex';
import overLayGoBack from '../components/overLayGoBack.vue';
import AutoCrossAnimation from '../assets/animation/Auto-Cross-Animation.json';

export default {
  name: 'KycFailure',
  components: { overLayGoBack },
  computed: {
    ...mapGetters(['transactionId'])
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      isOverLay: undefined,
      queryData: this.$route.query,
      AutoCrossAnimation,
      message: undefined
    };
  },
  methods: {
    init() {
      this.message = this.queryData?.msg || 'We could not verify your DigiLocker account!';
      setTimeout(() => {
        this.isOverLay = true;
      }, 5000);
    },
    handleBackToPrev() {
      this.isOverLay = false;
      setTimeout(() => {
        this.isOverLay = true;
      }, 4000);
    }
  }
};
</script>
<style lang="scss" scoped>
.width17rem{
  width: 17rem;
}
</style>
